<template>
  <div class="account-boxes">
    <DeployerUiBox :box-title="texts.title" :box-text="texts.text">
      <div class="team">
        <DeployerUiFormInputText
          v-model="teamName"
          :error="teamNameError"
          :label="texts.team_name"
          :tooltip="texts.team_name_tooltip"
          :show-initial-icon="true"
          :button-label="texts.save"
          :show-button="showSaveTeamButton"
          @button-click="saveTeamName"
        />
      </div>

      <div class="account-subtitle mt30" v-html="texts.plan_members" />

      <div class="team">
        <DeployerAccountTeamMember
          :person="currentTeamMember"
          :is-current-user="true"
        />
        <DeployerAccountTeamMember
          v-for="member in accountStore.team"
          :key="member.public_key"
          :person="member"
        />
      </div>

      <hr class="account-line" />

      <div class="account-subtitle mt30" v-html="texts.add_new_user" />
      <p class="account-subtext" v-html="texts.add_new_user_text" />
      <DeployerAccountAddUser />
    </DeployerUiBox>
  </div>
</template>

<script setup>
const accountStore = useAccountStore()
const newWalletStore = useNewWalletStore()

const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.team)

const teamName = ref('')
const teamNameError = ref('')

const showSaveTeamButton = computed(() => {
  return !(teamName.value === accountStore.teamName || teamName.value === '')
})

const saveTeamName = () => {
  console.log('save team name')

  //TODO: Kamil - implement save team name functionality
}

const currentTeamMember = computed(() => {
  const notOwner = accountStore.team.find(
    (member) => member.public_key !== newWalletStore?.account?.address
  )

  if (notOwner) {
    return notOwner
  }

  return {
    public_key: newWalletStore?.account?.address,
    access_level: 'Plan manager',
    username: '(You)'
  }
})

onMounted(() => {
  teamName.value = accountStore.teamName
})

watch(
  () => accountStore.teamName,
  () => {
    teamName.value = accountStore.teamName
  }
)
</script>

<style lang="scss" scoped>
.team {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 10px;
  margin-top: 10px;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
}
</style>
